import { toast } from "react-toastify";
import { endpoints } from "../../../../configs/Settings";
import { HTTPResponseStatus } from "../../../../utils/enum";

import { useAuth } from "../../../../utils/useAuth";
import { useAxios } from "../../../../utils/useAxios";
import { auxiliarData } from "../../AuxiliarData";

export async function PostResultJson(objData: any, encounter: any, refs: any) {
  let url = `${endpoints.XDSB_domain}/mhd/fhir`;

  const data = auxiliarData.DocumentReferenceJson(objData, encounter, refs);
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 60000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostDocumentReference Json: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostDocumentReference Json ", error);
      // toast.error(
      //   `PostDocumentReference Json Error: ${error?.response?.status}`
      // );
      throw new Error();
    });
    try {
      const parsed = JSON.parse(data);
      const uuidValue = parsed?.entry?.[0]?.resource?.id;
      return { response, uuidValue };
    } catch (e) {
      const uuidValue = undefined;
      return { response, uuidValue };
    }
}
